import {transform, includes} from 'lodash';
import {AnyObject} from 'types';

const reserved = [
  'autoFocus',
  'children',
  'className',
  'dangerouslySetInnerHTML',
  'disabled',
  'draggable',
  'href',
  'html',
  'id',
  'onBlur',
  'onClick',
  'onDoubleClick',
  'onDrop',
  'onFocus',
  'onInput',
  'onPaste',
  'placeholder',
  'rel',
  'role',
  'style',
  'tabIndex',
  'title'
];

export function getElementAttributes(props: AnyObject) {
  return transform(props, (attributes: AnyObject, value, key) => {
    if (/^(data-|aria-|onMouse|onKey|onDrag|onTouch|onPointer)/.test(key) || includes(reserved, key)) {
      attributes[key] = value;
    }
    return attributes;
  });
}
